import React, { useRef } from 'react';
import useClickOutside from '../UseClickOutside';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Publish, clearSceneAssets } from '../../pages/Dashboard/GridPage';
import useFocusTrap from '../../Hooks/useFocusTrap';
import store from '../../redux/store';
import { clearAssets } from '../../redux/Slice/gridSlice';
import { clearParticles } from '../../redux/Slice/particleSlice';
import { cleanAllAnimationObjects } from '../../redux/Slice/animationSlice';
import { lightDataUpdate } from '../../redux/Slice/gridSlice';

export const SaveProjectConfirmationModal = ({
  isOpen,
  onClose,
  onSave,
  setPublished,
  setProjectConfirmation,
  name,
  setName,
  scene,
  transformControls,
}) => {
  const navigate = useNavigate();
  const modalRef = useRef(null);
  const cancelButtonRef = useRef(null);
  const saveButtonRef = useRef(null);

  // Use the centralized focus trap hook
  useFocusTrap(isOpen, onClose, cancelButtonRef, saveButtonRef, saveButtonRef);

  useClickOutside(modalRef, () => {
    setProjectConfirmation(false);
  });
  if (!isOpen) return null;
  const project_name = name;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
      aria-modal="true"
      role="dialog"
      aria-labelledby="save-modal-title"
      aria-describedby="save-modal-description"
    >
      <div
        ref={modalRef}
        className="bg-[#1d1e21] p-6 rounded-lg shadow-lg  sm:w-[380px] md:w-[450px] xl:w-[500px] h-auto min-h-[170px] border-2 border-[#2d2e32]"
      >
        <h1 id="save-modal-title" className="font-bold text-white text-[20px]">
          Confirmation save?
        </h1>
        <h2
          id="save-modal-description"
          className="text-[14px] font-semibold text-white opacity-45"
        >
          Are you sure you want to save your project?
        </h2>
        <div className="h-[2px] w-full relative mt-4 bg-[#2d2e32] p-0"></div>
        {/* Buttons */}
        <div className="flex justify-end mt-9 space-x-3">
          <button
            ref={cancelButtonRef}
            onClick={() => {
              // Clear scene objects and Redux state so unsaved assets don't
              // persist when the user returns to the same or another project.
              try {
                if (scene && transformControls) {
                  clearSceneAssets(scene, transformControls);
                }
              } catch (_) {}
              store.dispatch(lightDataUpdate([]));
              store.dispatch(
                clearAssets([
                  'sceneMeshes',
                  'sceneHotspots',
                  'sceneImages',
                  'sceneVideos',
                  'sceneAudios',
                  'sceneText',
                  'imageScales',
                  'videoScales',
                  'audioScales',
                  'events',
                  'allIntersectedObjects',
                  'select_object',
                  'openModals',
                ])
              );
              store.dispatch(clearParticles());
              store.dispatch(cleanAllAnimationObjects());
              localStorage.removeItem('activeComponents');
              localStorage.removeItem('availableOptions');
              onClose();
              navigate('/dashboard');
            }}
            className="px-4 py-[6px] bg-[#2d2e32] text-[#ffffff] rounded-[8px] border-2 border-white border-opacity-5 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-40 focus:ring-offset-1 focus:ring-offset-[#1d1e21] transition duration-200"
          >
            Cancel
          </button>

          <button
            ref={saveButtonRef}
            onClick={async () => {
              onSave();

              await Publish(setPublished, false, setName);
              setProjectConfirmation(false);

              setTimeout(() => {
                navigate('/dashboard');
              }, 2000);
            }}
            className="px-4 py-[6px] min-w-[84px] bg-[#ee2b2a] text-white rounded-[8px] focus:outline-none focus:ring-2 focus:ring-[#ee2b2a] focus:ring-offset-1 focus:ring-offset-[#1d1e21] transition duration-200"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};
